export const environment = {
  rebrandlyAPIKey: "48598fa6dd3e4237b18dd6344b77a049",
  googleAnalyticsKey: "UA-7401895-54",
};
